// Generated types for ProductQueryExtractionTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { NeoNodeReadAPI } from '../../shared/types/neonode';
import { TaskReadAPI, TaskWriteAPI } from '../../tasks/types/task';
import { NeoNodeReadAPISchema } from '../../shared/types/neonode';
import { TaskReadAPISchemaObject, TaskWriteAPISchemaObject } from '../../tasks/types/task';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ProductQueryExtractionTaskReadAPI extends TaskReadAPI {
}

export interface ProductQueryExtractionTaskWriteAPI extends TaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ProductQueryExtractionTaskReadAPISchema: z.ZodType<ProductQueryExtractionTaskReadAPI> = TaskReadAPISchemaObject.extend({}).passthrough();

export const ProductQueryExtractionTaskWriteAPISchema: z.ZodType<ProductQueryExtractionTaskWriteAPI> = TaskWriteAPISchemaObject.extend({}).passthrough();
